import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import PostsPage from "./pages/PostsPage";
import SinglePostPage from "./pages/SinglePostPage";
import PagesPage from "./pages/PagesPage";
import SinglePagePage from "./pages/SinglePagePage";
import Footer from "./components/Footer/Footer";
import PageNotFound from "./pages/PageNotFound";
import CategoriesPage from "./pages/CategoriesPage";
import SingleCategoryPage from "./pages/SingleCategoryPage";
import SearchPage from "./pages/SearchPage";
import HistoryPage from "./pages/HistoryPage";
import SingleHistoryPage from "./pages/SingleHistoryPage";

function App() {
	return (
		<BrowserRouter>
			<Header />
			<Switch>
				<Route path="/" exact>
					<PostsPage />
				</Route>
				<Route path="/posts/:id" exact>
					<SinglePostPage />
				</Route>
				<Route path="/historie" exact>
					<HistoryPage />
				</Route>
				<Route path="/historie/:id" exact>
					<SingleHistoryPage />
				</Route>
				<Route path="/pages" exact>
					<PagesPage />
				</Route>
				<Route path="/pages/:id" exact>
					<SinglePagePage />
				</Route>
				<Route path="/categories" exact>
					<CategoriesPage />
				</Route>
				<Route path="/categories/:id" exact>
					<SingleCategoryPage />
				</Route>
				<Route path="/search" exact>
					<SearchPage />
				</Route>
				<Route path="*">
					<PageNotFound />
				</Route>
			</Switch>
			<Footer />
		</BrowserRouter>
	);
}

export default App;
